// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LayoutOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm6 14H5V5h4v14zM19 3h-6v8h8V5a2 2 0 00-2-2zm0 6h-4V5h4v4zM13 21h6a2 2 0 002-2v-6h-8v8zm2-6h4v4h-4v-4z","fill":"currentColor"}}]},"name":"layout","theme":"outlined"};

const LayoutOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LayoutOutlinedSvg} />;
  LayoutOutlined.displayName = 'LayoutOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LayoutOutlined);
